import axios from 'axios';

const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  ?.getAttribute('content');

const api = axios.create({
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
});

if (csrfToken) {
  api.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      const method = String(error.config?.method || '').toLowerCase();
      const pathname = window.location?.pathname || '';
      const isAccountPage = pathname.startsWith('/account');

      // Avoid hard-redirecting on public pages (e.g. property search) if a
      // background GET accidentally hits an authenticated endpoint.
      // Keep redirect behaviour for account pages and mutating requests.
      if (isAccountPage || (method && method !== 'get')) {
        window.location.href = '/account/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
